import request from '../http'

/** 获取当前用户所有 Token 列表 */
export function listDebugTokens() {
  return request({ url: '/system/fbDebug/tokens', method: 'get' })
}

/** 获取所有广告账户列表 */
export function listDebugAccounts() {
  return request({ url: '/system/fbDebug/accounts', method: 'get' })
}

/** Debug Token — 查询权限 */
export function debugToken(data) {
  return request({ url: '/system/fbDebug/debugToken', method: 'post', params: data })
}

/** 查询公共主页 */
export function queryPages(data) {
  return request({ url: '/system/fbDebug/queryPages', method: 'post', params: data })
}

/** 查询 BM 和公共主页 */
export function queryBmAndPages(data) {
  return request({ url: '/system/fbDebug/queryBmAndPages', method: 'post', params: data })
}

/** 查询 Pixel 列表 */
export function queryPixels(data) {
  return request({ url: '/system/fbDebug/queryPixels', method: 'post', params: data })
}

/** 查询批次请求 */
export function queryBatchRequests(data) {
  return request({ url: '/system/fbDebug/queryBatchRequests', method: 'post', params: data })
}

/** 按账户查询 Pixel */
export function queryAccountPixels(data) {
  return request({ url: '/system/fbDebug/queryAccountPixels', method: 'post', params: data })
}

/** 按账户查询可投放的公共主页 */
export function queryPromotePages(data) {
  return request({ url: '/system/fbDebug/queryPromotePages', method: 'post', params: data })
}

/** 手动触发 BM + 账户同步 */
export function syncBmAndAccounts(data) {
  return request({ url: '/system/fbDebug/syncBmAndAccounts', method: 'post', params: data })
}

/** 翻页 — 请求 next URL */
export function fetchNextPage(data) {
  return request({ url: '/system/fbDebug/nextPage', method: 'post', params: data })
}
